import script from "./SwitchLang.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwitchLang.vue?vue&type=script&setup=true&lang=ts"

import "./SwitchLang.vue?vue&type=style&index=0&id=268a2733&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-268a2733"]])

export default __exports__